<div class="card-information">
  <app-section-header [title]="'Card Information'" />
  <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields; let i = index;"
      [ngClass]="{'col-4': (i === 0), 'col-8': (i === 1)}">
      <form-field [formField]="formField" [form]="form"></form-field>
    </div>
  </form>
</div>